<div class="single-select-wrapper relative" [class]="styleClass" [class.dropdown-open]="isOpen">
  <div 
    class="single-select-trigger w-full min-w-[200px] bg-white cursor-pointer transition-all duration-200 relative"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    (click)="toggleDropdown()"
  >
    <div class="flex items-center justify-between">
      <div class="flex-1 flex flex-wrap gap-2 min-h-[24px] items-center">
        <!-- Placeholder when no item selected -->
        <span 
          *ngIf="!selectedValue" 
          class="single-select-placeholder text-sm"
        >
          {{ placeholder }}
        </span>
        
        <!-- Show chip when item is selected -->
        <span
          *ngIf="selectedValue"
          class="single-select-chip"
        >
          <span class="flex-shrink-0">{{ getDisplayValue() }}</span>
          <svg
            *ngIf="showClear && !disabled"
            class="single-select-clear-icon w-3 h-3 cursor-pointer"
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            (click)="clearSelection($event); $event.stopPropagation()"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </span>
      </div>
      
      <div class="flex items-center gap-2 flex-shrink-0 ml-2">
        <!-- Caret icon -->
        <svg 
          class="single-select-icon w-5 h-5 transition-transform duration-200"
          [class.rotate-180]="isOpen"
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Dropdown Panel -->
  <div
    *ngIf="isOpen && options && options.length > 0"
    class="dropdown-panel absolute w-full mt-1 shadow-xl max-h-60 overflow-auto"
    style="top: 100%; left: 0; min-width: 200px;"
    (click)="$event.stopPropagation()"
  >
    <!-- Options List -->
    <div class="py-1">
      <div
        *ngFor="let option of options; trackBy: trackByOption"
        [class]="getOptionClasses(option)"
        (click)="selectOption(option)"
      >
        <!-- Checkbox -->
        <div class="flex items-center mr-3 flex-shrink-0">
          <input
            type="checkbox"
            [checked]="isSelected(option)"
            class="w-4 h-4 checkbox-custom border-gray-300 rounded focus:ring-2 cursor-pointer"
            (click)="$event.stopPropagation(); selectOption(option)"
            readonly
          />
        </div>
        
        <!-- Option Label -->
        <span 
          class="single-select-option-label text-sm flex-1"
          [class.is-selected]="isSelected(option)"
          [class.font-medium]="isSelected(option)"
        >
          {{ getOptionLabel(option) }}
        </span>
      </div>
      
      <div *ngIf="options.length === 0" class="single-select-empty px-3 py-2 text-sm text-center">
        No options available
      </div>
    </div>
  </div>
</div>
